module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ui_title_line', {
    attrs: {
      "no_left": ""
    }
  }, [_vm._v("\n      СТАТЬИ\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 mr-mob"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col link-art"
  }, [_c('ul', _vm._l((_vm.article), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('router-link', {
      staticStyle: {
        "text-decoration": "underline"
      },
      attrs: {
        "to": item.href
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  }), 0)])])])]), _vm._v(" "), (_vm.art) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "title-art"
  }, [_vm._v("\n          " + _vm._s(_vm.art.title) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text-art"
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin": "0em 1em 1em 0em"
    },
    attrs: {
      "src": _vm.art.img
    }
  }), _vm._v("\n          " + _vm._s(_vm.art.text) + "\n        ")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-home pre-title"
  }, [_c('div', {
    staticClass: "col title-home-text"
  }, [_vm._v("СТАТЬИ АДВОКАТОВ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bbe76e0a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Article/article.vue
// module id = 375
// module chunks = 2